<div class="app-wrapper white-themw">
  <app-header *ngIf="term"></app-header>
  <div class="page-content">
    <div class="container">
      <app-data-side-nav *ngIf="route.includes('/data') && !route.includes('/menu/data')"></app-data-side-nav>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>

  </div>
  <!-- <app-footer></app-footer> -->
</div>